export default __webpack_public_path__ + "static/media/Montserrat_Light.4bee82c2.woff2";